import * as React from "react";

function Tnc() {
  return (
    <div>
      <iframe
        src="https://d3fjoujm1f7we5.cloudfront.net/tnc/troak-tnc.html"
        title="Terms and Conditions"
        style={{ width: "100%", height: "100vh", border: "none" }}
      ></iframe>
    </div>
  );
}

export default Tnc;
